import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {UserService} from "./user.service";
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from "rxjs";
import {UserModel} from "../model/user.model";

@Injectable()
export class AccessGuardService  {
  constructor (
    private service: UserService,
    private router: Router
) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getUserPromise().pipe(
      map((e: any) => {
        if (!(e instanceof UserModel)) {
          e = new UserModel(e);
        }
        return e.isAdmin()
      }),
      catchError(val => {
        this.router.navigate(['/']);
        return of('Error: Unauthorized');
      })
    )
  }

}
